<template>
  <div class="top-panel">
    <div class="left-section">
       <img src="https://ztchecvzbsazdgbkuzzp.supabase.co/storage/v1/object/public/media-storage-bucket/mountain.jpg" alt="Logo" class="logo" @click="navigateToHome" />
          <h4 class="navbar-element">Courses</h4>
          <h4 class="navbar-element" @click="navigateToPricing">Pricing</h4>
          <h4 class="navbar-element">Business</h4>
    </div>
    <div class="center-section">
        <div class="search-container">
            <input type="text" class="search-input" v-model="searchInput" @input="search" :style="{backgroundImage: !searchInput ? 'url(https://images.jazelc.com/uploads/wowwoodys-m2e/search21.png)' : 'none'}" placeholder="      Search" />
                <ul v-if="searchInput" class="suggestions-list" @mousedown.stop>
                    <li v-for="(suggestion, index) in suggestions" :key="index" @click="selectSuggestion(suggestion)">
                      <span class="pi pi-search"></span>  {{   suggestion }}
                    </li>
                </ul>
          
        </div>
    </div>
    <div class="right-section">
          <div v-if="ustore.uData.role != 'service_role'" >
              <button @click="navigateToLogin" class="login-button">Log In</button>
              <!-- <button @click="navigateToSignup" class="signup-button">Sign Up</button> -->
          </div>
          <img  v-else src="https://ztchecvzbsazdgbkuzzp.supabase.co/storage/v1/object/public/media-storage-bucket/red_panda.jpeg" alt="Profile" class="profile-icon" @click="navigateToProfile" />
    </div>
  </div>
</template>

<script>
// v-if="store.appuser.role==='service_role'
// import Navbar from './Navbar.vue';
// import { supabase } from '@/supabase.js'
import "vue-select/dist/vue-select.css";
// import { useAuthStore } from '@/stores/authStores';
// import { onMounted } from 'vue';
import { default as ustore } from '@/stores/authStore.js';

// import { storeToRefs } from 'pinia'
 
export default {
  components: {
  },
   data() {
    return {
      logindisplay:true,
      profiledisplay:false,
      searchInput: '',
      suggestions: [],
      ustore:ustore,
      profile:{},
       items: [
        { id: 1, name: 'Apple' },
        { id: 2, name: 'Banana' },
        { id: 3, name: 'Orange' },
        { id: 4, name: 'Mango' },
        { id: 5, name: 'Pineapple' },
      ],
      selectedItem: null,
    };
  },
  //  mounted() {
  //   // You can fetch the user data when the component is mounted
  //   this.store.fetchUser();
  // },


  // setup() {

  //   const authStore = useAuthStore();

  //   const {boi} = storeToRefs(authStore);
  //   const { fetchUser } = storeToRefs(authStore);
  //   // const { logout } = authStore

  // return { boi, fetchUser};

  // },
  methods: {
    navigateToProfile() {
      this.$router.push(`/profile/`);
    },
     navigateToHome() {
      this.$router.push(`/`);
    },
     navigateToLogin() {
      this.$router.push(`/login/`);
    },
    navigateToSignup() {
      this.$router.push(`/signup/`);
    },
    navigateToPricing() {
      this.$router.push(`/pricing/`);
    },
      search() {
      // Perform your search logic here, for demo purpose I'll just use a simple array
      // You might want to fetch suggestions from an API
      this.suggestions = ['apple', 'banana', 'orange', 'pineapple']
        .filter(suggestion => suggestion.toLowerCase().includes(this.searchInput.toLowerCase()));
    },
    selectSuggestion(suggestion) {
      this.searchInput = suggestion;
    },

  },
 
};
</script>

<style scoped>


.top-panel {
  display: flex;
  width: 100%;
  /* justify-content: space-between; */
  justify-content: center;
  margin: 0 auto;
  align-items: center;
  background: var(--sec-col);
  /* background-color:#ffff99; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}



.center-section {
  display: flex;
  max-width: 50%;
  align-items: center;
} 



.left-section{
  display: flex;
  /* max-width: 20%; */
  width: 20vw;
  /* color: #2b0a5d; */
  color:cyan;
  font-size: 110%;
  /* font-size: 1.36vw; */
  gap: 15%;
  /* margin-left: 1%; */
  margin-right: auto;
  align-items: center;
}



.right-section {
  display: flex;
  max-width: 30%;
  margin-left: auto;
  align-items: center;
}



.logo {
  width: 50px;
  height: 50px;
  cursor: pointer;
  padding: 8px;
}

.search-bar {
  flex: 1; /* Take up available space */
  padding: 10px; /* Adjust padding as needed */
  margin-left: 2px; /* Add margin to separate from the logo */
  border: 1px solid #ccc;
  border-radius: 4px;
}




.profile-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  margin-right: 15px;
}

.login-button {
  width: 90px;
  height: 50px;
  border-radius: 7%;
  cursor: pointer;
  margin-right: 10px;
  background-color: #ffff99;
  color: #2b0a5d;
  border: 2px solid #2b0a5d;
  font-size: 14px;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}

.signup-button {
  width: 90px;
  height: 50px;
  border-radius: 7%;
  cursor: pointer;
  margin-right: 20px;
  background-color: #2b0a5d;
  color: #ffff99;
  border: 2px solid #2b0a5d;
  font-size: 14px;
  visibility: visible;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}



.search-container {
    position: relative;
    /* display: block; */
    display: flex;
}

.search-input {
  /* width: 400px; */
  width: 35vw;
  padding: 8px 12px;
  font-size: 16px;
  background-image: url('https://images.jazelc.com/uploads/wowwoodys-m2e/search21.png');
  border: 1px solid #ccc;
  background:var(--prime-col);
  background-size: 25px 25px;
  background-repeat: no-repeat;
  background-position: 5px center;
  color: whitesmoke;
  border-radius: 4px;
}

.suggestions-list {
  position: absolute;
  top: 100%;
  left: 0;
  text-align: left;
  z-index: 1000;
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  list-style: none;
}

.suggestions-list li {
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.suggestions-list li:hover {
  background-color: #f0f0f0;
}


.navbar-element{
  cursor: pointer;
}

.navbar-element:hover{
  color:gray ;
}


/*Media Queries*/

@media only screen and (max-width: 1200px) {
   .search-input{
    max-width: 20vw;
    margin-left: 30vw;
  }
}

@media only screen and (max-width: 800px) {
  /* .top-panel{
    max-width: 100%;
  } */
  .search-input{
    max-width: 35vh;
    margin-left: 0;
  }
  .subtopic-menu{
    max-width: 0%;
  }
  .navbar-element{
    width: 0px;
    visibility: hidden;
  }
  .signup-button{
    width: 0vw;
    height: 0vh;
    display: none;
  }
  .login-button{
    width: 70px;
    height: 50px;
  }
 
}


</style>